/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholders_SearchInputs */

const en_placeholders_search = /** @type {(inputs: Placeholders_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Placeholders_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const placeholders_search = /** @type {((inputs?: Placeholders_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_search(inputs)
});